export type StoreSheetSearch = {
  reward?: number
  item?: number
}

/**
 * Idempotente — o router reparseia o retorno após gravar na URL.
 * Mesmo padrão de `feed/index.tsx` (`post`, `comments`).
 */
export const validateStoreSheetSearch = (
  search: Record<string, unknown>
): StoreSheetSearch => ({
  reward: Number(search.reward) || undefined,
  item: Number(search.item) || undefined
})

export const buildStoreItemSheetSearch = ({
  rewardId,
  rewardItemId
}: {
  rewardId: number
  rewardItemId: number
}): StoreSheetSearch => ({
  reward: rewardId,
  item: rewardItemId
})

export const buildStoreItemSheetHref = (
  rewardId: number,
  rewardItemId: number
) => {
  const params = new URLSearchParams({
    reward: String(rewardId),
    item: String(rewardItemId)
  })

  return `/lojinha?${params.toString()}`
}

export const isStoreSheetSearchActive = (search: StoreSheetSearch) =>
  typeof search.reward === 'number' && typeof search.item === 'number'

export const clearStoreSheetSearch = (): StoreSheetSearch => ({
  reward: undefined,
  item: undefined
})
